import { SourceData } from '@/components/control/TableSelectBox'

export const LOAN_TYPE_BRIDGE: SourceData = { value: 'BRIDGE', name: '브릿지' }
export const LOAN_TYPE_PF: SourceData = { value: 'PF', name: 'PF' }
export const LOAN_TYPE_MORTGAGE: SourceData = { value: 'MORTGAGE', name: '담보' }
export const LOAN_TYPE_AMOUNT_COMPLETED: SourceData = { value: 'AMOUNT_COMPLETED', name: '기성고' }

export const LOAN_TYPE_LIST: SourceData[] = [ LOAN_TYPE_BRIDGE, LOAN_TYPE_PF, LOAN_TYPE_AMOUNT_COMPLETED, LOAN_TYPE_MORTGAGE ]
